module.exports = { "default": require("core-js/library/fn/weak-set"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.26.0@babel-runtime/core-js/weak-set.js
// module id = 481
// module chunks = 115